import { api } from "../../services";
import { $config } from "../../conf";

export let wechatAPI = {
  /**
   * 查询某些微信用户关注微信号公众号的情况
   * @param openIds 粉丝ids
   * @returns {*}
   */
  onWechatContactsCheck({ openIds }) {
    return api.request("/api/wechat/contacts/check", {
      tenantId: $config.tenantId,
      weChatId: $config.weChatId,
      openIds,
    });
  },

  /**
   * 获取微信 jssdk 配置信息
   * @param jsApiList
   * @param url
   * @param onDebug
   * @returns {*}
   */
  onWechatJssdkConfigGet({ jsApiList, url, onDebug }) {
    return api.request("/api/wechat/jssdk/config/get", {
      tenantId: $config.tenantId,
      weChatId: $config.weChatId,
      jsApiList,
      url,
      onDebug,
    });
  },
};
